import { render, staticRenderFns } from "./zone-select.vue?vue&type=template&id=54ba3a29&scoped=true&"
import script from "./zone-select.vue?vue&type=script&lang=ts&"
export * from "./zone-select.vue?vue&type=script&lang=ts&"
import style0 from "./zone-select.vue?vue&type=style&index=0&id=54ba3a29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba3a29",
  null
  
)

export default component.exports